module.exports = __webpack_public_path__ + "img/icon_slider_button_disabled.669d27df.png";